// Country list — generated from the backend's own data (CountryManager data.json).
// ISO-3166 alpha-2 (uppercase, matches what the booking API stores/expects); Italian labels.
// Common destinations first, then alphabetical.
export interface Country { code: string; name: string }

export const COUNTRIES: Country[] = [
  { code: "IT", name: "Italia" },
  { code: "DE", name: "Germania" },
  { code: "FR", name: "Francia" },
  { code: "CH", name: "Svizzera" },
  { code: "AT", name: "Austria" },
  { code: "NL", name: "Paesi Bassi" },
  { code: "BE", name: "Belgio" },
  { code: "ES", name: "Spagna" },
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AG", name: "Antigua e Barbuda" },
  { code: "SA", name: "Arabia Saudita" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AZ", name: "Azerbaigian" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrein" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BY", name: "Bielorussia" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia-Erzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BR", name: "Brasile" },
  { code: "BN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "KH", name: "Cambogia" },
  { code: "CM", name: "Camerun" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Capo Verde" },
  { code: "TD", name: "Ciad" },
  { code: "CL", name: "Cile" },
  { code: "CN", name: "Cina" },
  { code: "CY", name: "Cipro" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comore" },
  { code: "CG", name: "Congo" },
  { code: "KP", name: "Corea del Nord" },
  { code: "KR", name: "Corea del Sud" },
  { code: "CI", name: "Costa d'Avorio" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croazia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "CuraÁao" },
  { code: "DK", name: "Danimarca" },
  { code: "DM", name: "Dominica" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egitto" },
  { code: "SV", name: "El Salvador" },
  { code: "AE", name: "Emirati Arabi Uniti" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Etiopia" },
  { code: "RU", name: "Federazione russa" },
  { code: "FJ", name: "Figi" },
  { code: "PH", name: "Filippine" },
  { code: "FI", name: "Finlandia" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "GH", name: "Ghana" },
  { code: "JM", name: "Giamaica" },
  { code: "JP", name: "Giappone" },
  { code: "GI", name: "Gibilterra" },
  { code: "DJ", name: "Gibuti" },
  { code: "JO", name: "Giordania" },
  { code: "GR", name: "Grecia" },
  { code: "GD", name: "Grenada" },
  { code: "GL", name: "Groenlandia" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GQ", name: "Guinea equatoriale" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Irlanda" },
  { code: "IS", name: "Islanda" },
  { code: "IM", name: "Isola di Man" },
  { code: "KY", name: "Isole Cayman" },
  { code: "CK", name: "Isole Cook (NZ)" },
  { code: "FK", name: "Isole Falkland (Malvine)" },
  { code: "FO", name: "Isole FÊr ÿer" },
  { code: "MH", name: "Isole Marshall" },
  { code: "PN", name: "Isole Pitcairn" },
  { code: "SB", name: "Isole Salomone" },
  { code: "TC", name: "Isole Turks e Caicos" },
  { code: "VG", name: "Isole Vergini britanniche" },
  { code: "IL", name: "Israele" },
  { code: "JE", name: "Jersey" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KG", name: "Kirghizistan" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "LA", name: "Laos" },
  { code: "LS", name: "Lesotho" },
  { code: "LV", name: "Lettonia" },
  { code: "LB", name: "Libano" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libia" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lituania" },
  { code: "LU", name: "Lussemburgo" },
  { code: "MK", name: "Macedonia del Nord" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldive" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MA", name: "Marocco" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Maurizio" },
  { code: "MX", name: "Messico" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MZ", name: "Mozambico" },
  { code: "MM", name: "Myanmar/Birmania" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NO", name: "Norvegia" },
  { code: "NC", name: "Nuova Caledonia" },
  { code: "NZ", name: "Nuova Zelanda" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestina" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua Nuova Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Per˘" },
  { code: "PF", name: "Polinesia francese" },
  { code: "PL", name: "Polonia" },
  { code: "PT", name: "Portogallo" },
  { code: "QA", name: "Qatar" },
  { code: "UK", name: "Regno Unito" },
  { code: "CZ", name: "Repubblica ceca" },
  { code: "CF", name: "Repubblica Centrafricana" },
  { code: "CD", name: "Repubblica Democratica del Congo" },
  { code: "DO", name: "Repubblica Dominicana" },
  { code: "RO", name: "Romania" },
  { code: "RW", name: "Ruanda" },
  { code: "EH", name: "Sahara occidentale" },
  { code: "KN", name: "Saint Kitts e Nevis" },
  { code: "PM", name: "Saint Pierre e Miquelon" },
  { code: "VC", name: "Saint Vincent e Grenadine" },
  { code: "BL", name: "Saint-BarthÈlemy" },
  { code: "MF", name: "Saint-Martin (FR)" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "SH", name: "Sant'Elena" },
  { code: "LC", name: "Santa Lucia" },
  { code: "ST", name: "Sao TomÈ e Principe" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten (NL)" },
  { code: "SY", name: "Siria" },
  { code: "SK", name: "Slovacchia" },
  { code: "SI", name: "Slovenia" },
  { code: "SO", name: "Somalia" },
  { code: "LK", name: "Sri Lanka" },
  { code: "FM", name: "Stati Federati di Micronesia" },
  { code: "US", name: "Stati Uniti d'America" },
  { code: "VA", name: "Stato della Citt‡ del Vaticano" },
  { code: "SS", name: "Sud Sudan" },
  { code: "ZA", name: "Sudafrica" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SE", name: "Svezia" },
  { code: "TJ", name: "Tagikistan" },
  { code: "TW", name: "Taiwan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TF", name: "Terre australi e antartiche francesi" },
  { code: "TH", name: "Thailandia" },
  { code: "TL", name: "Timor Leste" },
  { code: "TG", name: "Togo" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad e Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turchia" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TV", name: "Tuvalu" },
  { code: "UA", name: "Ucraina" },
  { code: "UG", name: "Uganda" },
  { code: "HU", name: "Ungheria" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "WF", name: "Wallis e Futuna" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
]
